import { AnimationTriggerMetadata, animate, state, style, transition, trigger } from '@angular/animations';

/**
 * Fades an element in/out on adding/removing it to/from DOM.
 * Requires a boolean trigger (`@name`) to be set on the element.
 * @param name - trigger name
 * @param duration - animation duration in secs
 * @param delay - animation delay in secs
 */
export function fadeOnAddRemove(name: string, duration = 0.25, delay = 0): AnimationTriggerMetadata {
  return trigger(name, [
    state('void', style({ opacity: 0 })),
    state('*', style({ opacity: 1 })),
    transition(':enter, :leave', animate(`${duration}s ${delay}s`))
  ]);
}
